import { IPromotionLogicInterface } from '@gongxigames/framework/promotions';

export interface IGameSessionPromotionInterface extends IPromotionLogicInterface {
    subtractPromotion(): void;
    hasPromotion(): boolean;
}
